import { useRef, useState, useCallback, useMemo } from "react";
import classNames from "classnames";
import { useTranslation } from 'react-i18next';

import "./Select.scss";

import ButtonDropdown from "components/uiComponents/ButtonDropdown";
import { getBounding } from "utils/elementExt";

const Select = (
  {
    title,
    options,
    selectedValue,
    setSelectedValue,
    isBold,
    withAbsolutePosition,
    placeholder,
    textSize = 'lg',
    selectSize,
    dropdownVerticalPosition="bottom",
    customContainerClass,
    isSmallHeight,
    isDropdownInModal,
  }
) => {
  const { t } = useTranslation();

  const [isDropdownShow, setIsDropdownShow] = useState(false);

  const selectRef = useRef()

  const openSidebarHandler = useCallback(() => {
    setIsDropdownShow(true)
  },[])
  
  const closeSidebarHandler = useCallback(() => {
    setIsDropdownShow(false)
  },[])

  const renderSelect = useMemo(() => {
    const _placeholder = placeholder ?? t('please_select_value');

    const selectFinalClasses = classNames(
      "column-select",
      {
        "column-select-sm": selectSize === "sm",
        "column-select-md": selectSize === "md",
        active: isDropdownShow,
      }
    );

    const titleFinalClass = classNames(
      "column-select_title",
      {
        "column-select--bold": isBold,
      }
    )

    const valueFinalClass = classNames({
      "column-select_value" : true,
      "column-select--bold": isBold,
    })

    return (
      <>
        <div
          ref={selectRef}
          className={selectFinalClasses}
          onClick={openSidebarHandler}
        >
          {
            title ? <div className={titleFinalClass}>{title}</div> : null 
          }
          {selectedValue?.value ? (
            <div className={valueFinalClass}>{selectedValue.value}</div>
          ) : (
            <div className="column-select_placeholder">{_placeholder}</div>
          )}
        </div>
      </>
    );
  }, [selectedValue, isDropdownShow, title, isBold, selectSize, placeholder, t, openSidebarHandler]);

  const renderOption = (item) => {
    const handleClickDropdownItem = () => {
      setIsDropdownShow(false);
      setSelectedValue(item);
    };
    
    const optionFinalClasses = classNames({
        "dropdown-item": true,
        "selected": item?.key === selectedValue?.key
      })
    
    return (
      <div
        className={optionFinalClasses}
        onClick={handleClickDropdownItem}
        key={item?.key}
      >
        {t(item?.value)}
      </div>
    );
  };

  const selectRect = getBounding(selectRef.current) ?? null
 
  return (
    <div className={`column-select-text--${textSize}`}>
      <ButtonDropdown
        buttonElement={renderSelect}
        dropdownVerticalPosition={dropdownVerticalPosition}
        isFullWidth
        buttonElementRect={selectRect}
        withAbsolutePosition={withAbsolutePosition}
        onCloseDropdown={closeSidebarHandler}
        customContainerClass={customContainerClass}
        dropDownCloseStatus={isDropdownShow}
        isSmallHeight={isSmallHeight}
        isDropdownInModal={isDropdownInModal}
      >
        {options ?
          options.map(renderOption) : null
        }
      </ButtonDropdown>
    </div>
  );
};

export default Select;
